import React from 'lib/react';
import {
  EVGrid, EVTypography,
} from 'lib/components';
import PropTypes from 'prop-types';
import clsx from 'lib/clsx';
import { ACCOUNT_LEVEL } from 'constants/AppConstants';
import MembershipLevelStyles from './MembershipLevelStyles';

function MembershipLevel(props) {
  const {
    level,
  } = props;
  const classes = MembershipLevelStyles();
  return (
    <EVGrid className={classes.membershipLevelContainer}>
      {
      level !== ACCOUNT_LEVEL.CUSTOM
      && (
      <>
        <EVGrid className={classes.inactiveBronze}>
          <EVTypography className={classes.inactiveText}>{ACCOUNT_LEVEL.BRONZE}</EVTypography>
        </EVGrid>
        <EVGrid className={classes.inactiveSilver}>
          <EVTypography className={classes.inactiveText}>{ACCOUNT_LEVEL.SILVER}</EVTypography>
        </EVGrid>
        <EVGrid className={classes.inactiveSilver}>
          <EVTypography className={classes.inactiveText}>{ACCOUNT_LEVEL.GOLD}</EVTypography>
        </EVGrid>
        <EVGrid className={classes.inactivePlat}>
          <EVTypography className={classes.inactiveText}>{ACCOUNT_LEVEL.PLATINUM}</EVTypography>
        </EVGrid>
      </>
      )
      }
      <EVGrid className={clsx(classes.activeTitle, level)}>
        <EVTypography className={classes.activeText}>{level}</EVTypography>
      </EVGrid>
    </EVGrid>
  );
}

MembershipLevel.propTypes = {
  level: PropTypes.string.isRequired,
};

export default MembershipLevel;
